import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Package } from "lucide-react";

export const TrackLookupPage = () => {
  const [orderId, setOrderId] = useState("");
  const [phone, setPhone] = useState("");
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const id = orderId.trim().toLowerCase();
    if (!id) { toast.error("Enter your order ID"); return; }
    if (phone.replace(/\D/g, "").length < 4) { toast.error("Enter at least the last 4 digits of your phone"); return; }
    // OrderTrackPage will use this phone via localStorage — but simpler: pass via query
    nav(`/order/${id}?phone=${encodeURIComponent(phone)}`);
  };

  return (
    <div className="max-w-lg mx-auto px-4 sm:px-6 py-10 pb-24 md:pb-16" data-testid="track-lookup-page">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#8E6377] hover:text-[#D81B60] mb-4">
        <ArrowLeft size={16} /> Back home
      </Link>
      <div className="bg-white rounded-3xl border border-[#F4D8E2] p-6 shadow-[0_10px_40px_rgba(216,27,96,0.08)]">
        <div className="w-12 h-12 rounded-full bg-[#FCE4EC] text-[#D81B60] flex items-center justify-center mb-4"><Package size={22} /></div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#D81B60] font-bold">Track / Cancel</p>
        <h1 className="font-serif text-3xl text-[#2D0A22] mt-1">Find your order</h1>
        <p className="text-sm text-[#8E6377] mt-2">Enter your order ID and the phone number used at checkout.</p>

        <form onSubmit={submit} className="mt-5 space-y-3">
          <input
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            placeholder="Order ID (e.g. 5e7d92ab)"
            className="w-full px-4 py-3 rounded-xl border border-[#F4D8E2] bg-[#FDF2F5] text-sm"
            data-testid="track-orderid-input"
          />
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Phone (last 4 digits or full)"
            className="w-full px-4 py-3 rounded-xl border border-[#F4D8E2] bg-[#FDF2F5] text-sm"
            data-testid="track-phone-input"
          />
          <button type="submit" className="w-full pill-btn" data-testid="track-submit">
            View my order
          </button>
        </form>

        <p className="mt-4 text-xs text-[#8E6377]">Need our policies? <Link to="/policies" className="text-[#D81B60] underline">Cancellation, refund &amp; return</Link></p>
      </div>
    </div>
  );
};
